import { Icon } from "@coverme/icons";
import * as PropTypes from "prop-types";
import React from "react";

export function MiniFacesheetOtherFinancial({ assets, expenses, debts, ...props }) {
    return (
        <>
            {expenses?.length > 0 && (
                <div>
                    <h4>Expenses</h4>
                    {expenses?.map((x, i) => (
                        <p className="mini-facesheet__other-item" key={i}>
                            {x.type}: <span className="h4">${x.amount}</span>
                        </p>
                    ))}
                </div>
            )}
            {debts?.length > 0 && (
                <div>
                    <h4>Debts</h4>
                    {debts?.map((x, i) => (
                        <p className="mini-facesheet__other-item" key={i}>
                            {x.type}: <span className="h4">${x.amount}</span>
                        </p>
                    ))}
                </div>
            )}
            {assets?.length > 0 && (
                <div>
                    <h4>Assets</h4>
                    {assets?.map((x, i) => (
                        <p className="mini-facesheet__other-item" key={i}>
                            {x.type}: <span className="h4">${x.value}</span>
                        </p>
                    ))}
                </div>
            )}
        </>
    );
}

MiniFacesheetOtherFinancial.propTypes = {
    otherOpen: PropTypes.any,
    onClick: PropTypes.func,
    financialAssistance: PropTypes.any,
    prop3: PropTypes.func,
    prop4: PropTypes.func,
};
